<template>
  <svg width="100%" height="100%" viewBox="0 0 200 200" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule: evenodd; clip-rule: evenodd; stroke-linejoin: round; stroke-miterlimit: 2">
    <circle cx="100" cy="114.921" r="71.998" style="fill: none" />
    <clipPath id="_clip1">
      <circle cx="100" cy="114.921" r="71.998" />
    </clipPath>
    <g clip-path="url(#_clip1)">
      <path
        id="lines-corner"
        d="M39.001,76.725c8.907,-13.185 33.963,-13.31 60.921,-1.734c27.052,-11.651 52.209,-11.529 61.094,1.734l0.012,0c0.093,0.148 0.185,0.297 0.276,0.445l0.029,0.045c0.061,0.098 0.121,0.196 0.18,0.295c6.651,10.905 10.485,23.714 10.485,37.411c-0,39.737 -32.261,71.998 -71.998,71.998c-39.737,-0 -71.998,-32.261 -71.998,-71.998c0,-14.027 4.02,-27.122 10.97,-38.196l0.029,0Z"
        style="fill: url(#_Linear2)"
      />
      <ellipse id="core" cx="100" cy="92.003" rx="61.748" ry="47.426" style="fill: #300000" />
      <clipPath id="_clip3">
        <ellipse cx="100" cy="92.003" rx="61.748" ry="47.426" />
      </clipPath>
      <g clip-path="url(#_clip3)">
        <path d="M39.257,149.875c-6.033,-10.406 -9.478,-22.505 -9.478,-35.407c0,-38.991 31.465,-70.647 70.221,-70.647c38.756,0 70.221,31.656 70.221,70.647c-0,12.902 -3.445,25.001 -9.478,35.407l-121.486,0Z" style="fill: #2f2f2f" />
      </g>
      <circle id="eye-wrapper" cx="100" cy="124.174" r="41.023" />
      <clipPath id="_clip4">
        <circle cx="100" cy="124.174" r="41.023" />
      </clipPath>
      <g clip-path="url(#_clip4)">
        <g id="eye" ref="eye">
          <circle id="eyeball" cx="100" cy="124.174" r="38.281" />
          <path
            id="iris"
            d="M100,103.634c13.352,0 24.192,10.84 24.192,24.192c0,13.352 -10.84,24.193 -24.192,24.193c-13.352,-0 -24.192,-10.841 -24.192,-24.193c-0,-13.352 10.84,-24.192 24.192,-24.192Zm-0,9.435c8.145,0 14.757,6.613 14.757,14.757c0,8.145 -6.612,14.758 -14.757,14.758c-8.145,-0 -14.757,-6.613 -14.757,-14.758c-0,-8.144 6.612,-14.757 14.757,-14.757Z"
            style="fill: #2effde"
          />
        </g>
      </g>
      <path
        id="eye-corner"
        d="M142.343,124.972c1.773,0.257 3.447,0.53 5.017,0.818l0.063,-0.052c-0.827,25.465 -21.759,45.884 -47.423,45.884c-25.664,-0 -46.596,-20.419 -47.423,-45.884l0.063,0.052c1.57,-0.288 3.244,-0.561 5.017,-0.818c0.426,23.006 19.236,41.552 42.343,41.552c23.107,0 41.917,-18.546 42.343,-41.552Zm-83.701,-9.947c-1.896,0.264 -3.687,0.545 -5.365,0.843c3.933,-22.234 23.369,-39.143 46.723,-39.143c23.354,0 42.79,16.909 46.723,39.143c-1.678,-0.298 -3.469,-0.579 -5.365,-0.843c-4.188,-18.984 -21.126,-33.202 -41.358,-33.202c-20.232,-0 -37.17,14.218 -41.358,33.202Z"
        style="fill: url(#_Linear8)"
      />
      <path
        id="eye-border"
        d="M100,80.173c24.285,-0 44.001,19.716 44.001,44.001c-0,24.284 -19.716,44 -44.001,44c-24.285,0 -44.001,-19.716 -44.001,-44c0,-24.285 19.716,-44.001 44.001,-44.001Zm0,5.72c21.128,-0 38.281,17.153 38.281,38.281c-0,21.127 -17.153,38.28 -38.281,38.28c-21.128,0 -38.281,-17.153 -38.281,-38.28c0,-21.128 17.153,-38.281 38.281,-38.281Z"
        style="fill: url(#_Linear9)"
      />
      <path
        id="body"
        d="M147.423,125.738c10.666,-8.798 17.189,-20.566 17.189,-33.488c-0,-1.814 -0.129,-3.606 -0.38,-5.37c-0.138,-2.893 -0.791,-5.594 -1.996,-8.043l0.044,-0c6.185,10.605 9.718,22.936 9.718,36.084c-0,39.737 -32.261,71.998 -71.998,71.998c-39.737,-0 -71.998,-32.261 -71.998,-71.998c0,-13.148 3.533,-25.479 9.718,-36.084l0.051,-0c-1.245,2.507 -1.908,5.279 -2.032,8.25c-0.232,1.697 -0.351,3.419 -0.351,5.163c0,12.922 6.523,24.69 17.189,33.488c0.827,25.465 21.759,45.884 47.423,45.884l0.301,-0.001c25.526,-0.158 46.298,-20.517 47.122,-45.883Zm-94.107,-9.809c-7.18,-9.512 -11.396,-21.325 -11.396,-34.106c-0,-3.699 0.353,-7.318 1.062,-10.818c13.155,-17.078 33.812,-28.081 57.018,-28.081c23.206,-0 43.863,11.003 57.018,28.081c0.709,3.5 1.062,7.119 1.062,10.818c0,12.781 -4.216,24.594 -11.396,34.106c-3.864,-22.268 -23.312,-39.204 -46.684,-39.204c-23.372,0 -42.82,16.936 -46.684,39.204Z"
        style="fill: url(#_Radial10)"
      />
    </g>
    <path
      d="M40.498,121.409c-24.565,-7.036 -40.498,-18.314 -40.498,-31.018c-0,-14.677 21.265,-27.451 52.54,-33.979c-17.885,7.96 -29.379,18.934 -29.379,26.258c-0,6.976 10.426,13.23 26.875,17.444l-5.512,20.417l-4.026,0.878Zm114.978,-0.878l-5.512,-20.417c16.449,-4.214 26.875,-10.468 26.875,-17.444c0,-7.324 -11.494,-18.298 -29.379,-26.258c31.275,6.528 52.54,19.302 52.54,33.979c0,12.704 -15.933,23.982 -40.498,31.018l-4.026,-0.878Z"
      style="fill: url(#_Linear11)"
    />
    <clipPath id="_clip12">
      <path
        d="M40.498,121.409c-24.565,-7.036 -40.498,-18.314 -40.498,-31.018c-0,-14.677 21.265,-27.451 52.54,-33.979c-17.885,7.96 -29.379,18.934 -29.379,26.258c-0,6.976 10.426,13.23 26.875,17.444l-5.512,20.417l-4.026,0.878Zm114.978,-0.878l-5.512,-20.417c16.449,-4.214 26.875,-10.468 26.875,-17.444c0,-7.324 -11.494,-18.298 -29.379,-26.258c31.275,6.528 52.54,19.302 52.54,33.979c0,12.704 -15.933,23.982 -40.498,31.018l-4.026,-0.878Z"
      />
    </clipPath>
    <g clip-path="url(#_clip12)">
      <ellipse cx="100" cy="90.391" rx="100" ry="38.601" style="fill: url(#_Linear13)" />
      <path d="M100,47.93c44.859,-0 81.279,21.516 81.279,35.348c-0,13.832 -36.42,25.062 -81.279,25.062c-44.859,0 -81.279,-11.23 -81.279,-25.062c0,-13.832 36.42,-35.348 81.279,-35.348Z" style="fill: #898989; fill-opacity: 0.46" />
      <path d="M78.014,122.093l-38.921,6.899l5.15,-27.495l19.46,-4.244l14.311,24.84Zm43.972,0l38.921,6.899l-5.15,-27.495l-19.46,-4.244l-14.311,24.84Z" style="fill: #1b1b1b" />
    </g>
    <path d="M100,13.839l24.377,83.183l-24.377,31.237l-24.377,-31.237l24.377,-83.183Z" style="fill: url(#_Linear14)" />
    <clipPath id="_clip15">
      <path d="M100,13.839l24.377,83.183l-24.377,31.237l-24.377,-31.237l24.377,-83.183Z" />
    </clipPath>
    <g clip-path="url(#_clip15)">
      <rect x="75.623" y="13.839" width="24.379" height="114.42" style="fill-opacity: 0.17" />
      <path d="M73.72,95.682c-10.372,13.276 -9.215,32.203 2.698,44.116c13.016,13.016 34.151,13.016 47.166,-0c11.913,-11.913 13.071,-30.84 2.699,-44.116l-26.282,20.533l-26.281,-20.533Z" style="fill-opacity: 0.27" />
    </g>
    <defs>
      <linearGradient id="_Linear2" x1="0" y1="0" x2="1" y2="0" gradientUnits="userSpaceOnUse" gradientTransform="matrix(3.08202e-15,50.3332,-50.3332,3.08202e-15,100,74.6389)">
        <stop offset="0" style="stop-color: #6c0000; stop-opacity: 1" />
        <stop offset="1" style="stop-color: #470000; stop-opacity: 1" />
      </linearGradient>
      <linearGradient id="_Linear5" x1="0" y1="0" x2="1" y2="0" gradientUnits="userSpaceOnUse" gradientTransform="matrix(3.94282e-16,6.91643,-11.5521,7.59797e-16,100,108.005)">
        <stop offset="0" style="stop-color: #535353; stop-opacity: 1" />
        <stop offset="1" style="stop-color: #272727; stop-opacity: 1" />
      </linearGradient>
      <linearGradient id="_Linear7" x1="0" y1="0" x2="1" y2="0" gradientUnits="userSpaceOnUse" gradientTransform="matrix(5.08636e-15,75.3348,-83.0665,4.61292e-15,100,44.5764)">
        <stop offset="0" style="stop-color: #3d3d3d; stop-opacity: 1" />
        <stop offset="1" style="stop-color: #1d1d1d; stop-opacity: 1" />
      </linearGradient>
      <linearGradient id="_Linear8" x1="0" y1="0" x2="1" y2="0" gradientUnits="userSpaceOnUse" gradientTransform="matrix(4.32322e-15,70.6414,-70.6035,4.32554e-15,100,100.981)">
        <stop offset="0" style="stop-color: #5b0000; stop-opacity: 1" />
        <stop offset="0.63" style="stop-color: #6d0808; stop-opacity: 1" />
        <stop offset="0.83" style="stop-color: #9a1b1b; stop-opacity: 1" />
        <stop offset="1" style="stop-color: #cb2f2f; stop-opacity: 1" />
      </linearGradient>
      <linearGradient id="_Linear9" x1="0" y1="0" x2="1" y2="0" gradientUnits="userSpaceOnUse" gradientTransform="matrix(5.38856e-15,88.0018,-88.0018,5.38856e-15,100,80.1726)">
        <stop offset="0" style="stop-color: #7d7d7d; stop-opacity: 1" />
        <stop offset="1" style="stop-color: #161616; stop-opacity: 1" />
      </linearGradient>
      <radialGradient id="_Radial10" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="matrix(6.5635e-15,107.19,-107.19,6.5635e-15,100,79.7288)">
        <stop offset="0" style="stop-color: #ffd2d2; stop-opacity: 1" />
        <stop offset="0.5" style="stop-color: #a70000; stop-opacity: 1" />
        <stop offset="1" style="stop-color: #000; stop-opacity: 1" />
      </radialGradient>
      <linearGradient id="_Linear11" x1="0" y1="0" x2="1" y2="0" gradientUnits="userSpaceOnUse" gradientTransform="matrix(200,0,0,65.9625,-2.79776e-14,89.3933)">
        <stop offset="0" style="stop-color: #ddd; stop-opacity: 1" />
        <stop offset="1" style="stop-color: #989898; stop-opacity: 1" />
      </linearGradient>
      <linearGradient id="_Linear13" x1="0" y1="0" x2="1" y2="0" gradientUnits="userSpaceOnUse" gradientTransform="matrix(1.22465e-14,77.2017,-200,4.72724e-15,100,51.7898)">
        <stop offset="0" style="stop-color: #7d7d7d; stop-opacity: 1" />
        <stop offset="1" style="stop-color: #161616; stop-opacity: 1" />
      </linearGradient>
      <linearGradient id="_Linear14" x1="0" y1="0" x2="1" y2="0" gradientUnits="userSpaceOnUse" gradientTransform="matrix(2.98537e-15,114.42,-48.7548,7.0062e-15,100,13.839)">
        <stop offset="0" style="stop-color: #7d7d7d; stop-opacity: 1" />
        <stop offset="1" style="stop-color: #161616; stop-opacity: 1" />
      </linearGradient>
    </defs>
  </svg>
</template>

<script>
  import { onMounted, onUnmounted, ref } from 'vue'
  export default {
    name: 'Ball1',
    setup() {
      let eye = ref(null)
      let mouseX = 0
      let mouseY = 0
      let eyeCenterX = 0
      let eyeCenterY = 0
      let eyeWidth = 0
      let eyeHeight = 0
      // let minOffset = 0
      // let maxOffset = 0
      // const maxMultiplier = 2;

      function onTransform() {
        const { left, top, width, height } = eye.value.getClientRects()[0]
        eyeCenterX = left + width / 2
        eyeCenterY = top + height / 2
        eyeWidth = width
        eyeHeight = height
        // minOffset = -2 * width
        // maxOffset = 2 * height
        transformEye()
      }

      function onMouseMove(event = {}) {
        mouseX = event.clientX || 0
        mouseY = event.clientY || 0
        transformEye()
      }

      function transformEye() {
        const offsetX = mouseX - eyeCenterX
        const offsetY = mouseY - eyeCenterY
        // const validOffsetX = Math.max(Math.min(offsetX, maxOffset), minOffset);
        // const validOffsetY = Math.max(Math.min(offsetY, maxOffset), minOffset);
        const tx = (4 * offsetX) / eyeWidth
        const ty = (4 * offsetY) / eyeHeight
        const rx = 3 * tx
        const ry = 3 * ty
        eye.value.style.transform = `translate(${tx}%, ${ty}%) rotateY(${-rx}deg) rotateX(${ry}deg)`
      }

      onMounted(() => {
        eye.value.style.transformOrigin = 'center'
        window.addEventListener('mousemove', onMouseMove)
        window.addEventListener('scroll', onTransform)
        window.addEventListener('resize', onTransform)
        onTransform()
      })

      onUnmounted(() => {
        window.removeEventListener('mousemove', onMouseMove)
        window.removeEventListener('scroll', onTransform)
        window.removeEventListener('resize', onTransform)
      })

      return { eye }
    },
  }
</script>
